// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginForm-wrapper {
  margin: 13px 24px;
}

.loginForm-wrapper .heading {
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 14px;
}

.loginForm-wrapper #sendotpform .field-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.loginForm-wrapper #sendotpform .field-group .label {
  font-size: 16px;
  line-height: 19px;
}

.loginForm-wrapper #sendotpform .field-group .input-field {
  width: 100%;
  margin: 0px 10px;
  height: 38px; 
} 

.loginForm-wrapper #sendotpform .field-group .input-field input {
  width: 100%;
  height: 100%;
  border: 1px solid #979797;
  background: #ECECEC;
  padding: 2px 5px;
  outline: none;
}

.loginForm-wrapper #verifyOtpform .field-group {
  display: flex;
  align-items: center;
  margin-top: 21px;
  margin-bottom: 21px;
}

.loginForm-wrapper #verifyOtpform .field-group .label {
  width: 60px;
  margin-right: 17px
}

.loginForm-wrapper #verifyOtpform .field-group .input-field {
  width: 70px;
  height: 38px;
  margin-right: 14px;
}

.loginForm-wrapper #verifyOtpform .field-group .input-field input {
  width: 100%;
  height: 100%;
  border: 1px solid #979797;
  background: #ECECEC;
  padding: 2px 5px;
  outline: none;
  width: 100%;
}

.loginForm-wrapper #verifyOtpform .field-group.otp {
  margin-bottom: 8px;
}
.loginForm-wrapper #verifyOtpform .field-group.error {
  margin-top: 3px;
  margin-bottom: 21px;
}

.right {
  margin-left: auto;
}

a {
  color: #236abc;
  font-size: 12px;
  line-height: 14px;
}

.non-editable-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.non-editable-container {
  position: absolute;
  top: 0px;
  left: 0;
  height: 100%;
  z-index: 50;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;AACb","sourcesContent":[".loginForm-wrapper {\n  margin: 13px 24px;\n}\n\n.loginForm-wrapper .heading {\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 19px;\n  margin-bottom: 14px;\n}\n\n.loginForm-wrapper #sendotpform .field-group {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.loginForm-wrapper #sendotpform .field-group .label {\n  font-size: 16px;\n  line-height: 19px;\n}\n\n.loginForm-wrapper #sendotpform .field-group .input-field {\n  width: 100%;\n  margin: 0px 10px;\n  height: 38px; \n} \n\n.loginForm-wrapper #sendotpform .field-group .input-field input {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #979797;\n  background: #ECECEC;\n  padding: 2px 5px;\n  outline: none;\n}\n\n.loginForm-wrapper #verifyOtpform .field-group {\n  display: flex;\n  align-items: center;\n  margin-top: 21px;\n  margin-bottom: 21px;\n}\n\n.loginForm-wrapper #verifyOtpform .field-group .label {\n  width: 60px;\n  margin-right: 17px\n}\n\n.loginForm-wrapper #verifyOtpform .field-group .input-field {\n  width: 70px;\n  height: 38px;\n  margin-right: 14px;\n}\n\n.loginForm-wrapper #verifyOtpform .field-group .input-field input {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #979797;\n  background: #ECECEC;\n  padding: 2px 5px;\n  outline: none;\n  width: 100%;\n}\n\n.loginForm-wrapper #verifyOtpform .field-group.otp {\n  margin-bottom: 8px;\n}\n.loginForm-wrapper #verifyOtpform .field-group.error {\n  margin-top: 3px;\n  margin-bottom: 21px;\n}\n\n.right {\n  margin-left: auto;\n}\n\na {\n  color: #236abc;\n  font-size: 12px;\n  line-height: 14px;\n}\n\n.non-editable-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n}\n\n.non-editable-container {\n  position: absolute;\n  top: 0px;\n  left: 0;\n  height: 100%;\n  z-index: 50;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
